export default __webpack_public_path__ + "static/media/211.efce3aa5.jpg";